import { IsiDtoPlPopinRequest, IsiDtoPlPopinResponse } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlPopin";
import { IIsiUIFlowResult } from "../Core/IIsiUIFlowResult";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiPresentationLogic } from "./IsiPresentationLogic";


export class IsiPlPopin extends IsiPresentationLogic {

    constructor() {
        super("IsiPlPopinHandler");
    }

    /**
     * Nettoie les informations en session à la fermeture d'une popin
     * @returns
     */
    public async cleanSessionInfos(): Promise<IIsiUIFlowResult> {
        const dto = IsiDtoPlPopinRequest.fromJS({
            response: IsiDtoPlPopinResponse.fromJS({})
        });
        const result: IIsiUIFlowResultGeneric<IsiDtoPlPopinRequest> = await this.ajaxWithErrorHandling("CleanSessionInfos", dto, true);

        return result;
    }

}
